import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-appello-view',
  templateUrl: './form-appello-view.component.html',
  styleUrls: ['./form-appello-view.component.css']
})
export class FormAppelloViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
